module.exports = __webpack_public_path__ + "img/in-icon-4.41505760.png";